"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagCount = void 0;
const vue_1 = require("vue");
const Tag_1 = require("./Tag");
exports.TagCount = vue_1.default.component('tag-count', {
    props: {
        tag: {
            type: String,
        },
        count: {
            type: Number,
        },
        size: {
            type: String,
        },
        type: {
            type: String,
        },
    },
    components: {
        'tag': Tag_1.Tag,
    },
    methods: {
        getClasses: function () {
            const classes = ['tag-display'];
            if (this.count === 0 && this.tag !== 'escape') {
                classes.push('tag-no-show');
            }
            return classes.join(' ');
        },
        getCountClasses: function () {
            const classes = ['tag-count-display'];
            if (this.count === 0 && this.tag !== 'escape') {
                classes.push('tag-count-no-show');
            }
            return classes.join(' ');
        },
        getCount: function () {
            if (this.count === -1 && this.tag !== 'escape')
                return '?';
            return this.count;
        },
    },
    template: `<div :class="getClasses()">
        <tag :tag="tag" :size="size" :type="type"/>
        <span :class="getCountClasses()">{{ getCount() }}</span>
    </div>`,
});
//# sourceMappingURL=TagCount.js.map